import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import {
	ErrorDescription,
	ErrorTitle,
	ErrorPageWrapper,
	ErrorMessageContainer,
} from './Error.style'

const Error = () => {
	const { t } = useTranslation()
	const location = useLocation()

	const errorType = useMemo(
		() => location.pathname.slice(1),
		[location.pathname],
	)

	return (
		<ErrorPageWrapper>
			<ErrorMessageContainer>
				<ErrorTitle>{t(`error.${errorType}.title`)}</ErrorTitle>
				<ErrorDescription>
					{t(`error.${errorType}.description`)}
				</ErrorDescription>
			</ErrorMessageContainer>
		</ErrorPageWrapper>
	)
}

export default Error
